import Big from 'big.js';

// 统一转换为 Big
function toBig(value) {
  return new Big(value || 0);
}

// 加法
export function bigAdd(num1, num2, decimalPlaces = -1) {
  const result = toBig(num1).plus(toBig(num2));
  return decimalPlaces === -1
    ? result.toString() // 如果未传 decimalPlaces，则返回原始结果
    : result.toFixed(decimalPlaces, 0); // 0 表示直接截断，不四舍五入
}

// 乘法
export function bigMultiply(num1, num2, decimalPlaces = -1) {
  const result = toBig(num1).times(toBig(num2));
  return decimalPlaces === -1
    ? result.toString() // 如果未传 decimalPlaces，则返回原始结果
    : result.toFixed(decimalPlaces, 0); // 直接截断
}

// 减法
export function bigSubtract(num1, num2, decimalPlaces = -1) {
  const result = toBig(num1).minus(toBig(num2));
  return decimalPlaces === -1
    ? result.toString() // 如果未传 decimalPlaces，则返回原始结果
    : result.toFixed(decimalPlaces, 0); // 直接截断
}

// 除法
export function bigDivide(num1, num2, decimalPlaces = -1) {
  const bigNum2 = toBig(num2);
  if (bigNum2.eq(0)) throw new Error("除数不能为 0");

  const result = toBig(num1).div(bigNum2);
  return decimalPlaces === -1
    ? result.toString() // 如果未传 decimalPlaces，则返回原始结果
    : result.toFixed(decimalPlaces, 0); // 直接截断
}
